<script>
  import InputWithValidation from '../../../lib/components/InputField.svelte';
  import NumberFieldWithButtons from '../../../lib/components/NumberFieldWithButtons.svelte';
  import { TS } from '../../../config/translation-keys.js';
  import { t9n } from '../../../lib/translate.js';
  import session from '../../../lib/session';
  import DatePicker from '../../../lib/components/DatePicker.svelte';
  import TimePicker from '../../../lib/components/TimePicker.svelte';
  import { show_tutorial_screen } from '../../../lib/tutorials';
  import { onMount } from 'svelte';
  import { show_message } from '../../../lib/flash';


  export let task_done;
  export let hours;
  export let category_selector;
  export let time_hours_validation;
  export let start_date;
  export let end_date;
  export let start_time;
  export let end_time;
  export let time_next_flag = false;
  export let order;
  export let page_state;

  let hour_first;
  let hour_second;
  let is_same_timezone;

  // translated strings ------------------------------------------------------ //

  let title_task_done;
  let desc_req;
  let title_hours;
  let btn_prev;
  let btn_next;
  let based_on;
  let is_value_round = true;
  let add_range = false;
  let start_date_flag = false;
  let start_time_flag = false;
  let disabled_task = false;
  let start_time_valid = true;
  let end_time_valid = true;
  let current_date;
  let start_date_valid = true;
  let end_date_valid = true;
  let has_init = false;
  let labels = {};
  let is_safari = false;
  let choose_option_label
  let exact_date_label
  let enter_schedule_label
  let total_tooltip;
  let start_time_error;
  let end_time_error;
  let start_time_last_value;

  // labels.invalid = t9n(TS.NEW_ORDER_CALENDAR_INVALID);
  // labels.duration = t9n(TS.NEW_ORDER_CALENDAR_DURATION);
  // labels.start_date = t9n(TS.NEW_ORDER_CALENDAR_START_DATE);
  // labels.end_date = t9n(TS.NEW_ORDER_CALENDAR_END_DATE);
  // labels.start_time = t9n(TS.NEW_ORDER_CALENDAR_START_TIME);
  // labels.end_date = t9n(TS.NEW_ORDER_CALENDAR_END_DATE);
  // labels.equal


  let get_label = () => {
    let based;

    for (let i of $session.merchant.products) {
      if (i.product_id === category_selector) {
        based = t9n(i.based_on);
        based_on = i.based_on;
      }
    }

    if (based_on === 'product_based_price') {
      return $session.merchant.currency_sign;
    } else {
      return based;
    }
  };

  const get_min_val = () => {
    if (based_on === 'product_based_price') {
      let pp_min = $session.merchant.pilot_points_minimum;
      let pp_multiplier = $session.merchant.pilot_points_multiplier;
      let vat_percentage = $session.merchant.vat_percentage;
      let val = pp_min / pp_multiplier / (1 + vat_percentage);

      val = Number(val.toFixed(1));
      let decimal = Number((val - Math.floor(val)).toFixed(1));

      if (decimal <= 0.5 && decimal > 0) {
        return Number(Math.floor(val).toFixed(0)) + 0.5;
      }
      if (decimal > 0.5) {
        return Number(Math.floor(val).toFixed(0)) + 1;
      }
      if (decimal === 0) {
        return val;
      }
    } else {
      return 1;
    }
  };

  const is_round = () => {
    let decimal = Number((hours - Math.floor(hours)).toFixed(1));
    return !(decimal !== 0.5 && decimal !== 0);
  };

  const get_date = () => {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    if(month < 10){
      month = `0${date.getMonth() + 1}`;
    }
    let day = date.getDate();
    if(day < 10){
      day = `0${date.getDate()}`;
    }
    return `${year}-${month}-${day}`;
  }

  const translate_texts = () => {


    has_init = true;
    current_date = get_date();
    title_task_done = t9n(TS.NEW_ORDER_TIME_TASKDONE);
    desc_req = t9n(TS.NEW_ORDER_TIME_DESCREQ);
    title_hours = t9n(TS.NEW_ORDER_TIME_HOURS);
    btn_prev = t9n(TS.TABLE_BUTTON_PREV);
    btn_next = t9n(TS.TABLE_BUTTON_NEXT);
    labels.choose = t9n(TS.NEW_ORDER_CALENDAR_INVALID);
    labels.invalid = t9n(TS.NEW_ORDER_CALENDAR_INVALID_DATE);
    labels.duration = t9n(TS.NEW_ORDER_CALENDAR_DURATION);
    labels.start_date = t9n(TS.NEW_ORDER_CALENDAR_START_DATE);
    labels.end_date = t9n(TS.NEW_ORDER_CALENDAR_END_DATE);
    labels.start_time = t9n(TS.NEW_ORDER_CALENDAR_START_TIME);
    labels.end_time = t9n(TS.NEW_ORDER_CALENDAR_END_TIME);
    labels.equal = t9n(TS.NEW_ORDER_CALENDAR_EQUAL);
    choose_option_label =  t9n(TS.NEW_ORDER_TIME_CHOOSE_OPTION)
    exact_date_label = t9n(TS.NEW_ORDER_TIME_EXACT_DATE)
    enter_schedule_label = t9n(TS.NEW_ORDER_TIME_ENTER_SCHEDULE)
    total_tooltip = t9n(TS.TOOLTIPS_NEW_ORDER_TOTAL)
    if (!!start_date) start_date_valid = true;
    if (!!end_date) end_date_valid = true;
    if (start_date_valid && end_date_valid && end_time_valid && start_time_valid && !!start_date && !!end_date) {
      time_next_flag = true;
    }

    start_time_last_value = start_time;

    is_safari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
      navigator.userAgent &&
      navigator.userAgent.indexOf('CriOS') == -1 &&
      navigator.userAgent.indexOf('FxiOS') == -1;
  };

  const check_different_timezone = () => {
    let current_timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return current_timezone === $session.merchant.timezone;
  }

  const validate_dates = (start_date, end_date, start_time, end_time) => {
    let start = new Date(start_date);
    let current = new Date(current_date);
    let end = new Date(end_date);
    let max = new Date('2099-12-31');
    if(!!start_date && !!end_date){
      if(page_state === 'edit' || page_state === 'copy'){
        start_date_valid = start <= end;
      } else {
        start_date_valid = start >= current && start <= end;
      }

      end_date_valid = end >= start && end <= max;

      if(!!start_time && !!end_time){
        if (start.getTime() === end.getTime()) {
          let date1 = new Date('1970-01-01 ' + start_time);
          let date2 = new Date('1970-01-01 ' + end_time);
          if(date2 < date1){



            if(start_time_last_value === start_time){
              start_time_valid = true;
              end_time_valid = false;
              end_time_error = t9n(TS.NEW_ORDER_CALENDAR_INVALID_DATE);
            } else {
              start_time_valid = false;
              end_time_valid = true;
              start_time_error = t9n(TS.NEW_ORDER_CALENDAR_INVALID_DATE);
            }
          } else {
            if(start_time === end_time){


              if(start_time_last_value === start_time){
                start_time_valid = true;
                end_time_valid = false;
                end_time_error = labels.equal;
              } else {
                start_time_valid = false;
                end_time_valid = true;
                start_time_error = labels.equal;
              }


            } else {
              start_time_valid = true;
              end_time_valid = true;
            }

          }
        } else {
          start_time_valid = true;
          end_time_valid = true;
        }
      } else {

        start_time_valid = true;
        end_time_valid = true;
      }
    } else {
      start_time_valid = true;
      end_time_valid = true;
      start_date_valid = true;
      end_date_valid = true;
    }

    start_time_last_value = start_time;
  }

  const validate_fields = (start_date, end_date, start_time, end_time, task_done, hours) => {
    time_next_flag = false;
    disabled_task = !!start_date || !!end_date || !!start_time || !!end_time;
    validate_dates(start_date, end_date, start_time, end_time);
    let datetimes_valid = start_date_valid && end_date_valid && start_time_valid && end_time_valid;
    if(!!hours && is_round()){
      if(!!task_done){
        time_next_flag = true;
      } else {

        if(!!start_date){
          if(!!end_date){

            if(!start_time && !end_time){
                  time_next_flag = datetimes_valid;
            } else {
              if(!!start_time && !!end_time){
                time_next_flag = datetimes_valid;
              } else {
                time_next_flag = false;
              }
            }
          } else {
            time_next_flag = true;
          }
        } else {
          time_next_flag = false;
        }

      }
    } else {
      time_next_flag = false;
    }
  }

  // const validate_fields = (start_date, end_date, start_time, end_time, task_done, hours) => {
  //   if(!!hours) is_value_round = is_round();
  //   disabled_task = !!start_date || !!end_date || !!start_time || !!end_time;
  //
  //   if (end_time) {
  //     if (!!start_time) {
  //       end_time_valid = !!start_date;
  //     } else {
  //       end_time_valid = true;
  //     }
  //   }
  //
  //   if (start_time) {
  //     if (!!end_time) {
  //       start_time_valid = !!start_date;
  //     } else {
  //       start_time_valid = true;
  //     }
  //   }
  //
  //   if (!!start_date && !!end_date) {
  //     let start = new Date(start_date);
  //     let current = new Date(current_date);
  //     let end = new Date(end_date);
  //     start_date_valid = start >= current && start <= end;
  //   }
  //
  //   if (end_date) {
  //     let end = new Date(end_date);
  //     let start = new Date(start_date);
  //     let max = new Date('2099-12-31');
  //     end_date_valid = end >= start && end <= max;
  //   }
  //
  //   if (start_date_valid && end_date_valid && end_time_valid && start_time_valid && !!start_date) {
  //     console.log('szal1');
  //     time_next_flag = true;
  //     if (!!end_time && !start_time) {
  //       console.log('szal2');
  //       time_next_flag = false;
  //     }
  //   }
  //
  //   if(!!task_done && !!hours){
  //     console.log('szal3');
  //     time_next_flag = true;
  //   }
  //   if(!start_date && !end_date && !task_done && !!hours){
  //     console.log('szal4');
  //     time_next_flag = false;
  //   }
  //
  //   if(hours === null || hours === 0 || hours < get_min_val() || !is_value_round){
  //     time_next_flag = false;
  //   }
  // }

  

  $: validate_fields(start_date, end_date, start_time, end_time, task_done, hours)

  $: if (!!$session && !has_init) translate_texts();

  $: if (JSON.parse(window.localStorage.getItem('WP.tutorial.new_order'))) {
    show_tutorial_screen(true, 'new_order_o8', 200, 'orderer');

  }



  onMount(() => {
    is_same_timezone = true;
    // is_same_timezone
    // is_same_timezone = check_different_timezone();
    // if(!is_same_timezone) show_message(t9n(TS.DIFFERENT_TIMEZONE_ERROR), 'info_ok');
  });
</script>


<div class="center-mobile">
  <strong>{   choose_option_label }</strong>
  <div class='fade-in margin-min-24'>
    <div class='mdc-layout-grid__inner mobile-break'>
      <div class='mdc-layout-grid__cell--span-6'>

        <p>{   exact_date_label }</p>

        <div class='mobile-block' style='margin-bottom: 15px;'>
          <div style='width: 199px'>
            <DatePicker
              id='start-date'
              label={labels.start_date}
              bind:value={start_date}
              disabled={!!task_done || (page_state === 'edit' && !!order && order.applications.length > 0) || !is_same_timezone}
              min={current_date}
              invalid_text={labels.invalid}
              max={end_date} />
          </div>
          <div class='mobile-margin' style='width: 199px'>
            <DatePicker
              id='end-date'
              label={labels.end_date}
              bind:value={end_date}
              disabled={!!task_done || (page_state === 'edit' && !!order && order.applications.length > 0) || !is_same_timezone}
              valid={end_date_valid}
              min={start_date}
              is_end_date={true}
              invalid_text={labels.invalid}
              max='2099-12-31' />
          </div>
        </div>

        <div class='mobile-block' style='margin-bottom: 15px;'>
          <div style='width: 199px'>
            <TimePicker
              id='start-time'
              label={labels.start_time}
              bind:value={start_time}
              disabled={!!task_done || (page_state === 'edit' && !!order && order.applications.length > 0) || !is_same_timezone}
              valid={start_time_valid}
              invalid_text={end_time_error} />
          </div>
          <div class='mobile-margin' style='width: 199px'>
            <TimePicker
              id='end-time'
              label={labels.end_time}
              bind:value={end_time}
              disabled={!!task_done || (page_state === 'edit' && !!order && order.applications.length > 0) || !is_same_timezone}
              valid={end_time_valid}
              invalid_text={end_time_error} />
          </div>
        </div>
      </div>

      <div class='mdc-layout-grid__cell--span-6'>


        <p>{  enter_schedule_label }</p>

        <div style='display: flex'>
          <InputWithValidation
            id='task-done'
            type='text'
            label={title_task_done}
            name='task-done'
            bind:value={task_done}
            disabled={disabled_task}
            width='410px' />
        </div>

        <p />
      </div>
    </div>

    <p class='desktop-bottom'>{labels.duration}</p>

    <!-- Total duration -->
    <div style='display: flex; margin-top: 0px;' >

      {#if !!$session}
        <div data-tooltip={total_tooltip}>
          <NumberFieldWithButtons
            id='duration'
            type='text'
            label={get_label()}
            name='duration'
            bind:value={hours}
            width='199px'
            show_tooltip={false}
            bind:time_hours_validation
            min_val={get_min_val()} />
        </div>
      {/if}
    </div>
  </div>
</div>

  <!-- Back + Next -->
  <p />

  <div style='display: flex; justify-content: flex-end;'>
    <div style='margin-right: 10px;'>
      <button
        onclick='prev_tab()'
        class='mdc-button mdc-button--outlined margin-5'>
        <span class='mdc-button__ripple' />
        {btn_prev}
      </button>
    </div>

      <button
        disabled={!time_next_flag}
        onclick='next_tab()'
        class='mdc-button mdc-button--unelevated margin-5'>
        <span class='mdc-button__ripple' />
        {btn_next}
      </button>
  </div>



<style>

    /* Desktop Mode
       *******************************************************/
    @media (min-width: 1025px) {

        .mobile-break {
            grid-template-columns: repeat(12, minmax(0, 1fr));
        }

        .desktop-bottom {
            margin-top: 55px;
        }

        .center-mobile {
            padding-left: 50px;
            padding-right: 50px;
        }

        .mobile-block {
            display: flex;
        }

        .mobile-margin {
            margin-left: 11px;
        }
    }

    /* Tablet Mode
   *******************************************************/

    @media (min-width: 769px) and (max-width: 1024px) {
        .mobile-block {
            display: flex;
        }

        .mobile-margin {
            margin-left: 11px;
        }

        .center-mobile {
            width: 50%;
            margin: auto;
            padding-left: 0px;
            padding-right: 50px;
        }

        .mobile-break {
            grid-template-columns: none;
            grid-gap: 4px;
        }
    }

    /* Mobile Mode
      *******************************************************/
    @media (min-width: 0) and (max-width: 768px) {

        .center-mobile {
            padding-left: 0px;
            width: 35%;
            margin: auto;
            padding-right: 50px;
        }

        .mobile-break {
            grid-template-columns: none;
            grid-gap: 4px;
        }

        .mobile-block {
          display: block;
        }

        .mobile-margin {
            margin-left: 0;
            margin-top: 15px;
        }

        .desktop-bottom {
            margin-top: -1px;
        }

    }


</style>
